import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { MglMap, MglMarker, MglPopup, MglNavigationControl, MglGeolocateControl } from 'vue-mapbox';
import MapsMixin from '@/components/core/mapsMixin';
import MapService from '@/services/mapService';
import { mapState } from 'vuex';
var mapHeaderZoom = 12;
export default {
  name: 'CoreDtwinMapHeaderMap',
  components: {
    MglMap: MglMap,
    MglMarker: MglMarker,
    MglPopup: MglPopup,
    MglNavigationControl: MglNavigationControl,
    MglGeolocateControl: MglGeolocateControl
  },
  mixins: [MapsMixin],
  props: {
    favorite: {
      type: Boolean,
      required: false,
      default: false
    },
    spectrum: {
      type: Boolean,
      required: false,
      default: function _default() {
        return true;
      }
    },
    preview: {
      type: Boolean,
      required: false,
      default: false
    },
    header: {
      type: Boolean,
      required: false,
      default: false
    },
    dtwTitle: {
      type: String,
      required: false,
      default: ''
    },
    interactiveMap: {
      type: Boolean,
      required: false,
      default: false
    },
    fullScreenMap: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color'])), {}, {
    subTitle: function subTitle() {
      return this.get(this, 'dtwData.address.formatted_address');
    },
    classObject: function classObject() {
      if (this.preview && this.favorite) {
        return 'favoriteMap';
      } else if (this.preview) {
        return 'previewHeaderMap';
      } else if (this.fullScreenMap) {
        return 'headerMapFullScreen';
      }

      return 'headerMap';
    },
    markerCoordinates: function markerCoordinates() {
      return this.allowMultiCoordinates ? this.geoCoordinates[0].coordinates : this.geoCoordinates;
    },
    centerCoordinates: function centerCoordinates() {
      if (this.favorite) {
        // move map a bit down so the icon is not underneath the address label
        return [this.markerCoordinates[0], this.markerCoordinates[1] + 0.0006];
      }

      return this.markerCoordinates;
    }
  }),
  watch: {},
  created: function created() {
    this.map = null;
    this.zoomToUseFallback = mapHeaderZoom;
    this.zoomOffset = -1.5;
  },
  methods: {
    onMapLoaded: function onMapLoaded(event) {
      this.map = event.map; // Add 3D Buildings in case switched on in filter

      if (this.$store.state.app.map3DBuild) {
        MapService.add3DBuildingLayer(this.map);
      }

      this.drawOverlay();
      var zoomToUse = this.calculateZoomToUse();

      if (!this.allowScrollZoom) {
        this.map.scrollZoom.disable();
      } else {
        this.map.scrollZoom.enable();
      }

      this.addToAnimationQueue({
        center: this.centerCoordinates,
        pitch: 0,
        bearing: 0,
        zoom: zoomToUse,
        duration: this.animateFlyIn ? 2000 : 0,
        animate: this.animateFlyIn
      });
    },
    drawOverlay: function drawOverlay() {
      if (!this.map) {
        return;
      }

      if (!this.map.getSource('empty')) {
        // since there is no direct z-index property, create dummy layers under which stuff is positioned
        // drawOverlay should be called before any draw-controls for polygons are added,
        // as to make sure this is really at the bottom
        this.map.addSource('empty', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: []
          }
        });
        this.map.addLayer({
          id: 'groundLayer',
          type: 'symbol',
          source: 'empty'
        });
      }

      var overlayId = 'overlay';

      if (this.map.getLayer(overlayId)) {
        this.map.removeLayer(overlayId);
      }

      if (this.map.getSource(overlayId)) {
        this.map.removeSource(overlayId);
      }

      if (!this.overlayInfo) {
        return;
      }

      this.map.addSource(overlayId, {
        type: 'image',
        url: this.overlayInfo.image,
        coordinates: this.overlayInfo.coordinates
      });
      this.map.addLayer({
        id: overlayId,
        source: overlayId,
        type: 'raster',
        paint: {
          'raster-opacity': 1.0
        }
      }, 'groundLayer');
    }
  }
};